/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Workout_Adjusted_PlannedInputs */

const en_us2_workout_adjusted_planned = /** @type {(inputs: Workout_Adjusted_PlannedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} in the plan`)
};

const pt_br2_workout_adjusted_planned = /** @type {(inputs: Workout_Adjusted_PlannedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} no plano`)
};

const es_419_workout_adjusted_planned = /** @type {(inputs: Workout_Adjusted_PlannedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} en el plan`)
};

const pt_pt2_workout_adjusted_planned = /** @type {(inputs: Workout_Adjusted_PlannedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} no plano`)
};

const fr_fr2_workout_adjusted_planned = /** @type {(inputs: Workout_Adjusted_PlannedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} au programme`)
};

const de_de2_workout_adjusted_planned = /** @type {(inputs: Workout_Adjusted_PlannedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} im Plan`)
};

const it_it2_workout_adjusted_planned = /** @type {(inputs: Workout_Adjusted_PlannedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} nella scheda`)
};

/**
* | output |
* | --- |
* | "{count} in the plan" |
*
* @param {Workout_Adjusted_PlannedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_adjusted_planned = /** @type {((inputs: Workout_Adjusted_PlannedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Adjusted_PlannedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_adjusted_planned(inputs)
	if (locale === "es-419") return es_419_workout_adjusted_planned(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_adjusted_planned(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_adjusted_planned(inputs)
	if (locale === "de-DE") return de_de2_workout_adjusted_planned(inputs)
	if (locale === "it-IT") return it_it2_workout_adjusted_planned(inputs)
	return en_us2_workout_adjusted_planned(inputs)
});
export { workout_adjusted_planned as "workout.adjusted_planned" }